import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

// Thêm font Maven Pro từ Google Fonts
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400;700&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);

// Đặt màu nền cho toàn bộ trang là đen và thêm CSS
const style = document.createElement('style');
style.textContent = `
  html, body {
    background-color: #000000;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  }
  .custom-input::placeholder {
    color: #42433D;
  }
  .custom-input:focus {
    outline: none;
  }
  .custom-input::-webkit-inner-spin-button,
  .custom-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .custom-input[type="number"] {
    -moz-appearance: textfield;
  }
`;
document.head.appendChild(style);

// Sử dụng biến môi trường cho API URL
const API_URL = process.env.REACT_APP_API_URL || 'http://192.168.2.13:5001';
const WS_URL = API_URL.replace('http', 'ws');

function App() {
  const [isStarted, setIsStarted] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [stepData, setStepData] = useState({
    step1: { completed: false, data: {} },
    step2: { completed: false, data: {} },
    step3: { completed: false, data: {} },
    step4: { completed: false, data: [] },
  });
  const [matchHistory, setMatchHistory] = useState([]);
  const wsRef = useRef(null);
  const [hasLocation, setHasLocation] = useState(false);
  const [lastLocation, setLastLocation] = useState(null);
  const [hasAttemptedLocation, setHasAttemptedLocation] = useState(false);
  const [isSelfArrived, setIsSelfArrived] = useState(false);
  const [isOtherArrived, setIsOtherArrived] = useState(false);
  const [arrivedStatus, setArrivedStatus] = useState(null);
  const [arrivedMessage, setArrivedMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showCancelStep1Popup, setShowCancelStep1Popup] = useState(false);

  // Kết nối WebSocket
  useEffect(() => {
    if (!sessionId) return;

    const ws = new WebSocket(WS_URL);
    wsRef.current = ws;

    ws.onopen = () => {
      console.log('WebSocket connected');
      ws.send(JSON.stringify({ type: 'init', sessionId }));
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('WebSocket message received:', data);
    
      if (data.type === 'matchFound') {
        setStepData((prev) => ({
          ...prev,
          step2: { completed: true, data: prev.step2.data },
          step3: { completed: false, data: { name: data.meetLocation, address: data.address, link: data.link } },
        }));
        setCurrentStep(data.currentStep);
    
        // Cập nhật matchHistory khi tìm thấy ghép cặp
        axios
          .get(`${API_URL}/api/users/status?sessionId=${sessionId}`)
          .then((response) => {
            setMatchHistory(response.data.matchHistory || []);
          })
          .catch((error) => {
            console.error('Failed to update matchHistory:', error);
          });
      } else if (data.type === 'searchStopped') {
        console.log('Search stopped, resetting to Step 1');
        setCurrentStep(1);
        setStepData((prev) => ({
          ...prev,
          step1: { completed: false, data: prev.step1.data },
          step2: { completed: false, data: {} },
          step3: { completed: false, data: {} },
          step4: { completed: false, data: [] },
        }));
        setHasLocation(false);
        setLastLocation(null);
        setHasAttemptedLocation(false);
      } else if (data.type === 'arrivedSuccess') {
        setArrivedStatus('success');
        setArrivedMessage(data.message);
        if (data.isSelf) setIsSelfArrived(true);
        else setIsOtherArrived(true);
        setCurrentStep(data.currentStep);
        setStepData((prev) => ({
          ...prev,
          step3: {
            ...prev.step3,
            completed: data.currentStep === 4,
            error: null,
          },
        }));
      } else if (data.type === 'arrivedFailed') {
        setArrivedStatus('failed');
        setArrivedMessage(data.message);
        setStepData((prev) => ({
          ...prev,
          step3: { ...prev.step3, error: data.message },
        }));
      } else if (data.type === 'chatMessage') {
        setMessages((prev) => [
          ...prev,
          {
            sender: data.senderSessionId === sessionId ? 'Bạn' : 'Đối phương',
            text: data.text,
          },
        ]);
      } else if (data.type === 'resetToStep1') {
        console.log('Resetting to Step 1');
        setCurrentStep(1);
        setStepData((prev) => ({
          ...prev,
          step1: { completed: false, data: prev.step1.data },
          step2: { completed: false, data: {} },
          step3: { completed: false, data: {} },
          step4: { completed: false, data: [] },
        }));
        setMessages([]);
        setIsSelfArrived(false);
        setIsOtherArrived(false);
        setArrivedStatus(null);
        setArrivedMessage('');
        setHasLocation(false);
        setLastLocation(null);
        setHasAttemptedLocation(false);
      } else if (data.type === 'resetToStep2') {
        console.log('Resetting to Step 2');
        setCurrentStep(2);
        setStepData((prev) => ({
          ...prev,
          step2: { completed: false, data: prev.step2.data },
          step3: { completed: false, data: {} },
          step4: { completed: false, data: [] },
        }));
        setMessages([]);
        setIsSelfArrived(false);
        setIsOtherArrived(false);
        setArrivedStatus(null);
        setArrivedMessage('');
        setHasLocation(true);
      } else if (data.type === 'error') {
        console.error('WebSocket error:', data.message);
      }
    };

    ws.onclose = () => {
      console.log('WebSocket disconnected');
    };

    return () => {
      ws.close();
    };
  }, [sessionId]);

  // Khôi phục trạng thái khi tải trang
  useEffect(() => {
    const savedSessionId = localStorage.getItem('sessionId');
    if (savedSessionId) {
      setSessionId(savedSessionId);
      axios
        .get(`${API_URL}/api/users/status?sessionId=${savedSessionId}`)
        .then((response) => {
          setCurrentStep(response.data.currentStep);
          setStepData(response.data.stepData);
          setMatchHistory(response.data.matchHistory || []);
          setIsStarted(true);
          if (response.data.currentStep === 3 && response.data.stepData.step3.data.hasArrived) {
            setIsSelfArrived(response.data.stepData.step3.data.hasArrived);
          }
          if (response.data.currentStep === 4 && response.data.stepData.step4.data) {
            setMessages(
              response.data.stepData.step4.data.map((msg) => ({
                sender: msg.senderSessionId === savedSessionId ? 'Bạn' : 'Đối phương',
                text: msg.text,
              }))
            );
          }
        })
        .catch((error) => {
          console.error('Failed to restore status:', error);
          localStorage.removeItem('sessionId');
        });
    }
  }, []);

  // Hàm xóa dữ liệu người dùng và reset trạng thái
  const deleteUserData = async () => {
    try {
      await axios.delete(`${API_URL}/api/users/delete`, {
        data: { sessionId },
      });
      console.log('User data deleted');
      localStorage.removeItem('sessionId');
      setIsStarted(false);
      setSessionId(null);
      setCurrentStep(1);
      setStepData({
        step1: { completed: false, data: {} },
        step2: { completed: false, data: {} },
        step3: { completed: false, data: {} },
        step4: { completed: false, data: [] },
      });
      setMatchHistory([]);
      setMessages([]);
      setHasLocation(false);
      setLastLocation(null);
      setHasAttemptedLocation(false);
      setIsSelfArrived(false);
      setIsOtherArrived(false);
      setArrivedStatus(null);
      setArrivedMessage('');
      if (wsRef.current) {
        wsRef.current.close();
        wsRef.current = null;
      }
    } catch (error) {
      console.error('Failed to delete user data:', error);
    }
  };

  // Getting Started Screen
  const GettingStartedScreen = () => {
    const handleStart = async () => {
      try {
        const response = await axios.post(`${API_URL}/api/users/session`);
        const newSessionId = response.data.sessionId;
        setSessionId(newSessionId);
        localStorage.setItem('sessionId', newSessionId);
        setIsStarted(true);
      } catch (error) {
        console.error('Failed to create session:', error.message);
      }
    };

    return (
      <div
        style={{
          width: '100%',
          height: '100dvh',
          backgroundColor: '#0E100F',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <header
          style={{
            height: '168px',
            backgroundColor: '#0E100F',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src="/logo.svg" alt="Logo" style={{ width: '48px', height: '48px' }} />
        </header>
        <div
          style={{
            flex: 1,
            backgroundColor: '#0E100F',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '40px',
          }}
        >
          <div style={{ minWidth: '224px', borderRadius: '12px', textAlign: 'left', boxSizing: 'border-box' }}>
            <div style={{ fontFamily: 'Maven Pro, sans-serif', fontSize: '36px', color: '#0AE448', fontWeight: '700' }}>
              <div>Có</div>
              <div>Muốn hẹn hò</div>
              <div>Không</div>
            </div>
          </div>
          <div
            style={{
              minWidth: '312px',
              borderRadius: '12px',
              textAlign: 'left',
              boxSizing: 'border-box',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <span style={{ fontSize: '96px', color: '#0AE448', lineHeight: '1', fontFamily: 'Maven Pro, sans-serif', position: 'relative', top: '-6px' }}>
              {'{'}
            </span>
            <div style={{ fontFamily: 'Maven Pro, sans-serif', fontSize: '18px', color: '#DFFFD1', flex: 1 }}>
              <div>Tôi có thể sắp xếp ngay giúp bạn một cuộc hẹn</div>
              <div>Hãy chắc chắn bạn đã sẵn sàng để di chuyển</div>
            </div>
            <span style={{ fontSize: '96px', color: '#0AE448', lineHeight: '1', fontFamily: 'Maven Pro, sans-serif', position: 'relative', top: '-6px' }}>
              {'}'}
            </span>
          </div>
          <div
            style={{
              width: '312px',
              height: 64,
              backgroundColor: '#0AE448',
              borderRadius: '32px',
              color: '#0E100F',
              fontSize: '20px',
              fontFamily: 'Maven Pro, sans-serif',
              fontWeight: '700',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={handleStart}
          >
            Sắp xếp ngay
          </div>
        </div>
      </div>
    );
  };

  // Header với tiêu đề và button thay đổi theo bước
  const Header = () => {
    const handleStopSearch = () => {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        console.log('Sending stopSearch message');
        wsRef.current.send(JSON.stringify({ type: 'stopSearch', sessionId }));
      } else {
        console.error('WebSocket is not open');
      }
    };

    const handleCancelStep1 = () => {
      if (matchHistory && matchHistory.length > 0) {
        setShowCancelStep1Popup(true);
      } else {
        deleteUserData();
      }
    };

    const getHeaderContent = () => {
      switch (currentStep) {
        case 1:
          return { title: 'Nhập thông tin', buttonLabel: 'Thoát', action: handleCancelStep1 };
        case 2:
          return { title: 'Tìm kiếm', buttonLabel: 'Dừng', action: handleStopSearch };
        case 3:
          return {
            title: 'Đã tìm thấy',
            buttonLabel: 'Huỷ',
            action: () => setShowCancelPopup(true),
          };
        case 4:
          return { title: 'Nhắn tin', buttonLabel: 'Xong', action: () => setShowConfirmPopup(true) };
        default:
          return { title: 'Nhập thông tin', buttonLabel: 'Thoát', action: handleCancelStep1 };
      }
    };

    const { title, buttonLabel, action } = getHeaderContent();

    return (
      <header
        style={{
          background: '#0AE448',
          height: '64px',
          padding: '0 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxSizing: 'border-box',
        }}
      >
        <h2 style={{ fontSize: '20px', color: '#0E100F', margin: 0, fontFamily: 'Maven Pro, sans-serif' }}>{title}</h2>
        <button onClick={action} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
          <img src="/cancel.svg" alt={buttonLabel} style={{ width: '16px', height: '16px' }} />
        </button>
      </header>
    );
  };

  // Popup xác nhận hoàn thành cuộc hẹn
  const ConfirmPopup = () => {
    const handleConfirm = () => {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        console.log('Sending completeMeeting message');
        wsRef.current.send(JSON.stringify({ type: 'completeMeeting', sessionId }));
      } else {
        console.error('WebSocket is not open');
      }
      setShowConfirmPopup(false);
    };

    const handleCancel = () => {
      setShowConfirmPopup(false);
    };

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <div
          style={{
            backgroundColor: '#0E100F',
            padding: '24px',
            borderRadius: '12px',
            width: '80%',
            maxWidth: '400px',
            textAlign: 'center',
            fontFamily: 'Maven Pro, sans-serif',
            color: '#F3FFEE',
          }}
        >
          <h3 style={{ margin: '0 0 20px 0', fontSize: '18px' }}>Bạn đã hoàn thành cuộc hẹn?</h3>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <button
              onClick={handleConfirm}
              style={{
                padding: '10px 20px',
                backgroundColor: '#0AE448',
                color: '#0E100F',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '700',
              }}
            >
              Vâng
            </button>
            <button
              onClick={handleCancel}
              style={{
                padding: '10px 20px',
                backgroundColor: '#42433D',
                color: '#F3FFEE',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '700',
              }}
            >
              Chưa
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Popup xác nhận huỷ cuộc hẹn
  const CancelPopup = () => {
    const handleConfirm = () => {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        console.log('Sending cancelMeeting message');
        wsRef.current.send(JSON.stringify({ type: 'cancelMeeting', sessionId }));
      } else {
        console.error('WebSocket is not open');
      }
      setShowCancelPopup(false);
    };

    const handleCancel = () => {
      setShowCancelPopup(false);
    };

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <div
          style={{
            backgroundColor: '#0E100F',
            padding: '24px',
            borderRadius: '12px',
            width: '80%',
            maxWidth: '400px',
            textAlign: 'center',
            fontFamily: 'Maven Pro, sans-serif',
            color: '#F3FFEE',
          }}
        >
          <h3 style={{ margin: '0 0 20px 0', fontSize: '18px' }}>Bạn muốn huỷ cuộc hẹn?</h3>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <button
              onClick={handleConfirm}
              style={{
                padding: '10px 20px',
                backgroundColor: '#0AE448',
                color: '#0E100F',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '700',
              }}
            >
              Đúng
            </button>
            <button
              onClick={handleCancel}
              style={{
                padding: '10px 20px',
                backgroundColor: '#42433D',
                color: '#F3FFEE',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '700',
              }}
            >
              Không
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Popup xác nhận thoát bước 1 khi có matchHistory
  const CancelStep1Popup = () => {
    const handleConfirm = () => {
      deleteUserData();
      setShowCancelStep1Popup(false);
    };

    const handleCancel = () => {
      setShowCancelStep1Popup(false);
    };

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <div
          style={{
            backgroundColor: '#0E100F',
            padding: '24px',
            borderRadius: '12px',
            width: '80%',
            maxWidth: '400px',
            textAlign: 'center',
            fontFamily: 'Maven Pro, sans-serif',
            color: '#F3FFEE',
          }}
        >
          <h3 style={{ margin: '0 0 20px 0', fontSize: '18px' }}>
            Dữ liệu của bạn sẽ được xóa, bạn có thể sẽ được ghép cặp với người trước đó nếu quay lại
          </h3>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <button
              onClick={handleConfirm}
              style={{
                padding: '10px 20px',
                backgroundColor: '#0AE448',
                color: '#0E100F',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '700',
              }}
            >
              Vâng
            </button>
            <button
              onClick={handleCancel}
              style={{
                padding: '10px 20px',
                backgroundColor: '#42433D',
                color: '#F3FFEE',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '700',
              }}
            >
              Ở lại
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Step 1: Nhập giới tính và tuổi
  const Step1 = () => {
    const [gender, setGender] = useState(stepData.step1.data.gender || '');
    const [age, setAge] = useState(stepData.step1.data.age ? String(stepData.step1.data.age) : '');
    const [isGenderFocused, setIsGenderFocused] = useState(false);
    const [isAgeFocused, setIsAgeFocused] = useState(false);
    const [isGenderDropdownOpen, setIsGenderDropdownOpen] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async () => {
      const ageNum = parseInt(age);
      if (gender && age && ageNum >= 16 && ageNum <= 91) {
        try {
          await axios.post(`${API_URL}/api/users/profile`, {
            sessionId,
            gender,
            age: ageNum,
          });
          setStepData((prev) => ({
            ...prev,
            step1: { completed: true, data: { gender, age: ageNum } },
          }));
          setCurrentStep(2);
        } catch (err) {
          setError('Cập nhật thông tin thất bại. Vui lòng thử lại.');
        }
      } else {
        setError('Vui lòng chọn giới tính và nhập tuổi hợp lệ (16-91)!');
      }
    };

    const isGenderCompleted = gender !== '';
    const isAgeCompleted = age !== '' && parseInt(age) >= 16 && parseInt(age) <= 91;
    const isFormValid = gender && age && parseInt(age) >= 16 && parseInt(age) <= 91;
    const genderIndicatorColor = isGenderFocused || isGenderCompleted ? '#0AE448' : '#42433D';
    const ageIndicatorColor = isAgeFocused || isAgeCompleted ? '#0AE448' : '#42433D';
    const genderOptions = ['Nam', 'Nữ'];

    return (
      <div style={{ position: 'relative', height: 'calc(100dvh - 64px)', display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            backgroundColor: '#0E100F',
            color: '#FFFCE1',
            fontSize: '16px',
            fontFamily: 'Maven Pro, sans-serif',
            flex: 1,
            overflowY: 'auto',
            paddingBottom: '80px',
            boxSizing: 'border-box',
          }}
        >
          <p style={{ margin: '104px 0 30px 0', padding: '0 24px', color: '#42433D' }}>
            Bạn cần cung cấp cho tôi những thông tin sau
          </p>
          {error && <p style={{ color: 'red', padding: '0 24px' }}>{error}</p>}
          <div style={{ marginBottom: '20px', padding: '0 24px', position: 'relative' }}>
            <div
              style={{
                position: 'absolute',
                left: '24px',
                top: '25px',
                width: '8px',
                height: '8px',
                backgroundColor: genderIndicatorColor,
                borderRadius: '50%',
                clipPath: 'polygon(0 0, 100% 0, 100% 50%, 0 50%)',
                zIndex: 2,
              }}
            />
            <div
              onClick={() => setIsGenderDropdownOpen(!isGenderDropdownOpen)}
              onFocus={() => setIsGenderFocused(true)}
              onBlur={() => setIsGenderFocused(false)}
              tabIndex={0}
              style={{
                height: '50px',
                width: '100%',
                padding: '0 10px 0 20px',
                boxSizing: 'border-box',
                fontFamily: 'Maven Pro, sans-serif',
                fontSize: '16px',
                border: 'none',
                color: gender ? '#F3FFEE' : '#42433D',
                backgroundColor: '#0E100F',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              {gender || 'Giới tính của bạn'}
            </div>
            {isGenderDropdownOpen && (
              <div
                style={{
                  position: 'absolute',
                  top: '50px',
                  left: '24px',
                  right: '24px',
                  backgroundColor: '#0AE448',
                  color: '#0E100F',
                  fontFamily: 'Maven Pro, sans-serif',
                  fontSize: '16px',
                  borderRadius: '0',
                  zIndex: 10,
                  maxHeight: '100px',
                  overflowY: 'auto',
                }}
              >
                {genderOptions.map((option, index) => (
                  <div
                    key={option}
                    onClick={() => {
                      setGender(option);
                      setIsGenderDropdownOpen(false);
                    }}
                    style={{
                      padding: '10px 60px',
                      cursor: 'pointer',
                      borderBottom: index < genderOptions.length - 1 ? '1px solid #0E100F' : 'none',
                    }}
                  >
                    {option}
                  </div>
                ))}
              </div>
            )}
            {!isGenderDropdownOpen && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '24px',
                  right: '24px',
                  height: '4px',
                  backgroundColor: genderIndicatorColor,
                  borderRadius: '0',
                }}
              />
            )}
          </div>
          <div style={{ marginBottom: '0', padding: '0 24px', position: 'relative' }}>
            <div
              style={{
                position: 'absolute',
                left: '24px',
                top: '50%',
                transform: 'translateY(-50%)',
                width: '8px',
                height: '8px',
                backgroundColor: ageIndicatorColor,
                borderRadius: '50%',
                clipPath: 'polygon(0 50%, 100% 50%, 100% 100%, 0 100%)',
              }}
            />
            <input
              type="number"
              value={age}
              onChange={(e) => setAge(e.target.value)}
              onFocus={() => setIsAgeFocused(true)}
              onBlur={() => setIsAgeFocused(false)}
              placeholder="Tuổi của bạn"
              min="16"
              max="91"
              className="custom-input"
              style={{
                height: '50px',
                width: '100%',
                padding: '0 10px 0 20px',
                boxSizing: 'border-box',
                fontFamily: 'Maven Pro, sans-serif',
                fontSize: '16px',
                border: 'none',
                color: '#F3FFEE',
                backgroundColor: '#0E100F',
              }}
            />
            <div
              style={{
                position: 'absolute',
                bottom: '0',
                left: '24px',
                right: '24px',
                height: '4px',
                backgroundColor: ageIndicatorColor,
                borderRadius: '0',
              }}
            />
          </div>
        </div>
        <footer
          style={{
            position: 'absolute',
            bottom: 0,
            left: '0',
            right: '0',
            backgroundColor: '#0E100F',
            padding: '15px 24px 32px 24px',
            zIndex: 1,
          }}
        >
          <button
            onClick={handleSubmit}
            disabled={!isFormValid}
            style={{
              height: '64px',
              width: '100%',
              backgroundColor: '#0E100F',
              border: `4px solid ${isFormValid ? '#0AE448' : '#42433D'}`,
              color: isFormValid ? '#F3FFEE' : '#42433D',
              cursor: isFormValid ? 'pointer' : 'not-allowed',
              fontFamily: 'Maven Pro, sans-serif',
              fontSize: '20px',
              borderRadius: '32px',
              fontWeight: '700',
            }}
          >
            Bắt đầu tìm kiếm
          </button>
        </footer>
      </div>
    );
  };

  // Step 2: Tìm kiếm với vị trí và WebSocket
  const Step2 = () => {
    const [locationError, setLocationError] = useState('');
    const [permissionStatus, setPermissionStatus] = useState(null);
    const [showRetry, setShowRetry] = useState(false);
    const [permissionInstructions, setPermissionInstructions] = useState('');
    const canvasRef = useRef(null);
    const animationStartTime = useRef(null);
    const gridSize = 12;
    const cellSize = 18;
    const canvasWidth = gridSize * cellSize;
    const canvasHeight = gridSize * cellSize;

    const getPermissionInstructions = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
        return 'Vui lòng vào Cài đặt > Quyền riêng tư > Dịch vụ định vị > Safari > chọn "Khi dùng ứng dụng".';
      } else if (userAgent.includes('chrome')) {
        return 'Vui lòng vào Cài đặt > Quyền riêng tư và bảo mật > Cài đặt trang web > Vị trí > chọn "Cho phép".';
      } else if (userAgent.includes('firefox')) {
        return 'Vui lòng vào Cài đặt > Quyền riêng tư & Bảo mật > Quyền > Vị trí > chọn "Cho phép".';
      } else {
        return 'Vui lòng kiểm tra cài đặt trình duyệt để cấp quyền truy cập vị trí.';
      }
    };

    const checkLocationPermission = async () => {
      if ('permissions' in navigator) {
        try {
          const permission = await navigator.permissions.query({ name: 'geolocation' });
          setPermissionStatus(permission.state);
          permission.onchange = () => {
            setPermissionStatus(permission.state);
            setShowRetry(permission.state === 'denied');
            if (permission.state === 'denied') {
              setPermissionInstructions(getPermissionInstructions());
            } else {
              setPermissionInstructions('');
            }
          };
        } catch (error) {
          console.error('Error checking location permission:', error);
        }
      }
    };

    const getLocation = () => {
      if (navigator.geolocation) {
        setHasAttemptedLocation(true);
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
            setStepData((prev) => ({
              ...prev,
              step2: { ...prev.step2, data: { location } },
            }));
            setHasLocation(true);
            setLastLocation(location);
            setLocationError('');
            setShowRetry(false);
            setPermissionInstructions('');

            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
              wsRef.current.send(
                JSON.stringify({
                  type: 'locationUpdate',
                  sessionId,
                  location,
                })
              );
            }
          },
          (error) => {
            console.error('Location error:', error);
            if (error.code === error.PERMISSION_DENIED) {
              setLocationError('Bạn đã từ chối cấp quyền truy cập vị trí.');
              setPermissionInstructions(getPermissionInstructions());
              setShowRetry(true);
            } else if (error.code === error.POSITION_UNAVAILABLE) {
              setLocationError('Không thể lấy vị trí. Vui lòng kiểm tra xem GPS đã được bật chưa.');
              setShowRetry(true);
            } else if (error.code === error.TIMEOUT) {
              setLocationError('Hết thời gian lấy vị trí. Vui lòng thử lại.');
              setShowRetry(true);
            } else {
              setLocationError('Đã có lỗi xảy ra khi lấy vị trí. Vui lòng thử lại.');
              setShowRetry(true);
            }
          },
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
      } else {
        setLocationError('Trình duyệt không hỗ trợ lấy vị trí.');
        setShowRetry(true);
        setHasAttemptedLocation(true);
      }
    };

    useEffect(() => {
      checkLocationPermission();
      if (!hasAttemptedLocation) {
        getLocation();
      }
    }, []);

    useEffect(() => {
      if (!hasLocation) return;

      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      const animate = (timestamp) => {
        if (!animationStartTime.current) {
          animationStartTime.current = timestamp;
        }

        const elapsed = timestamp - animationStartTime.current;
        const cycleDuration = 3000;
        const progress = (elapsed % cycleDuration) / cycleDuration;

        const minRadius = 8;
        const maxRadius = 88;
        const animationProgress = progress < 0.6667 ? progress * 1.5 : 0;
        const currentRadius = minRadius + (maxRadius - minRadius) * animationProgress;

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        const activePositions = new Set();

        if (progress < 0.6667) {
          for (let i = 0; i < gridSize; i++) {
            for (let j = 0; j < gridSize; j++) {
              const x = (j - (gridSize - 1) / 2) * cellSize;
              const y = (i - (gridSize - 1) / 2) * cellSize;
              const distance = Math.sqrt(x * x + y * y);

              if (currentRadius >= distance - 8) {
                activePositions.add(`${i},${j}`);
                const neighbors = [
                  [i - 1, j],
                  [i + 1, j],
                  [i, j - 1],
                  [i, j + 1],
                ];
                neighbors.forEach(([ni, nj]) => {
                  if (ni >= 0 && ni < gridSize && nj >= 0 && nj < gridSize) {
                    activePositions.add(`${ni},${nj}`);
                  }
                });
              }
            }
          }
        }

        for (let i = 0; i < gridSize; i++) {
          for (let j = 0; j < gridSize; j++) {
            const isActive = activePositions.has(`${i},${j}`);
            ctx.beginPath();
            ctx.arc(j * cellSize + cellSize / 2, i * cellSize + cellSize / 2, 8, 0, Math.PI * 2);
            ctx.fillStyle = isActive ? '#42433D' : '#0E100F';
            ctx.fill();
          }
        }

        ctx.beginPath();
        ctx.arc(canvasWidth / 2, canvasHeight / 2, 4, 0, Math.PI * 2);
        ctx.fillStyle = '#0AE448';
        ctx.fill();

        if (progress < 0.6667) {
          const radius = (currentRadius - 4) * 2;
          ctx.beginPath();
          ctx.arc(canvasWidth / 2, canvasHeight / 2, radius / 2, 0, Math.PI * 2);
          ctx.strokeStyle = '#0AE448';
          ctx.lineWidth = 4;
          ctx.stroke();
        }

        if (progress >= 1) {
          animationStartTime.current = timestamp;
        }

        requestAnimationFrame(animate);
      };

      const animationFrameId = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationFrameId);
    }, [hasLocation]);

    if (!hasLocation) {
      return (
        <div
          style={{
            backgroundColor: '#0E100F',
            color: '#FFFCE1',
            textAlign: 'center',
            minHeight: 'calc(100dvh - 64px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            fontFamily: 'Maven Pro, sans-serif',
            fontSize: '16px',
            padding: '0 24px',
          }}
        >
          <div style={{ position: 'relative', width: `${canvasWidth}px`, height: `${canvasHeight}px`, margin: '104px auto 30px auto' }}>
            <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} width={canvasWidth} height={canvasHeight} />
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '8px',
                height: '8px',
                backgroundColor: '#0AE448',
                borderRadius: '50%',
              }}
            />
          </div>
          <p style={{ color: '#42433D' }}>Tôi cần vị trí hiện tại của bạn</p>
          {locationError && <p style={{ color: 'red', margin: '8px 0' }}>{locationError}</p>}
          {permissionInstructions && <p style={{ color: '#F3FFEE', margin: '8px 0', fontSize: '14px' }}>{permissionInstructions}</p>}
          {showRetry && (
            <button
              onClick={getLocation}
              style={{
                marginTop: '10px',
                padding: '10px 20px',
                backgroundColor: '#0AE448',
                color: '#0E100F',
                border: 'none',
                borderRadius: '20px',
                fontFamily: 'Maven Pro, sans-serif',
                fontSize: '16px',
                cursor: 'pointer',
              }}
            >
              Thử lại
            </button>
          )}
        </div>
      );
    }

    return (
      <div
        style={{
          backgroundColor: '#0E100F',
          color: '#FFFCE1',
          textAlign: 'center',
          minHeight: 'calc(100dvh - 64px)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          fontFamily: 'Maven Pro, sans-serif',
          fontSize: '16px',
          padding: '0 24px',
        }}
      >
        <div style={{ position: 'relative', width: `${canvasWidth}px`, height: `${canvasHeight}px`, margin: '104px auto 30px auto' }}>
          <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />
        </div>
        <p style={{ color: '#42433D' }}>Đang tìm người phù hợp ở gần bạn</p>
        {locationError && <p style={{ color: 'red' }}>{locationError}</p>}
      </div>
    );
  };

  // Step 3: Thông tin địa điểm và hướng dẫn
  const Step3 = () => {
    const handleSubmit = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
  
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
              wsRef.current.send(JSON.stringify({ type: 'arrived', sessionId, location }));
            }
          },
          (error) => {
            setStepData((prev) => ({
              ...prev,
              step3: { ...prev.step3, error: 'Không thể lấy vị trí. Vui lòng bật GPS.' },
            }));
          },
          { enableHighAccuracy: true }
        );
      } else {
        setStepData((prev) => ({
          ...prev,
          step3: { ...prev.step3, error: 'Trình duyệt không hỗ trợ lấy vị trí.' },
        }));
      }
    };
  
    const meetLocation = stepData.step3.data;
  
    return (
      <div style={{ position: 'relative', height: 'calc(100dvh - 64px)', display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            backgroundColor: '#0E100F',
            color: '#FFFCE1',
            fontSize: '16px',
            fontFamily: 'Maven Pro, sans-serif',
            flex: 1,
            overflowY: 'auto',
            paddingTop: '104px',
            paddingBottom: '80px',
            boxSizing: 'border-box',
          }}
        >
          <div style={{ border: '1px solid #42433D', borderRadius: '0', margin: '0 8px 24px 8px', padding: '24px 18px', textAlign: 'left' }}>
            <h3 style={{ margin: '0 0 8px 0', fontWeight: '700', color: '#F3FFEE' }}>Địa điểm gặp mặt</h3>
            <p style={{ margin: '0 0 8px 0', color: '#F3FFEE' }}>{meetLocation.name || 'The Coffee House'}</p>
            <p style={{ margin: '0 0 8px 0', color: '#F3FFEE' }}>Địa chỉ: {meetLocation.address || 'Somewhere between you two'}</p>
            {meetLocation.link && (
              <a
                href={meetLocation.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '10px 20px',
                  backgroundColor: '#0AE448',
                  color: '#0E100F',
                  borderRadius: '20px',
                  textDecoration: 'none',
                  fontWeight: '700',
                  marginTop: '8px',
                }}
              >
                Mở bản đồ
              </a>
            )}
            {arrivedMessage && <p style={{ margin: '8px 0 0 0', color: arrivedStatus === 'success' ? '#0AE448' : 'red' }}>{arrivedMessage}</p>}
          </div>
          <div style={{ margin: '0 24px', textAlign: 'left' }}>
            <p style={{ margin: '0 0 8px 0', color: '#42433D' }}>
              Mỗi 10 phút tôi sẽ kiểm tra GPS một lần, để chắc chắn bạn đang di chuyển về phía điểm hẹn. Nếu bạn không di chuyển, tôi sẽ tự động huỷ cuộc hẹn.
            </p>
            <p style={{ margin: '0', color: '#42433D' }}>
              Khi tôi xác nhận hai bạn đã đến nơi, tôi sẽ bật tính năng nhắn tin trực tiếp.
            </p>
            {stepData.step3.error && <p style={{ margin: '8px 0 0 0', color: 'red' }}>{stepData.step3.error}</p>}
          </div>
        </div>
        <footer
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#0E100F',
            padding: '15px 24px 32px 24px',
            zIndex: 1,
          }}
        >
          <button
            onClick={handleSubmit}
            style={{
              height: '64px',
              width: '100%',
              backgroundColor: '#0E100F',
              border: '4px solid #0AE448',
              borderRadius: '32px',
              color: '#F3FFEE',
              cursor: 'pointer',
              fontFamily: 'Maven Pro, sans-serif',
              fontWeight: '700',
              fontSize: '20px',
            }}
          >
            Đã đến nơi
          </button>
        </footer>
      </div>
    );
  };

  // Step 4: Nhắn tin
  const Step4 = () => {
    const [message, setMessage] = useState('');
    const messagesEndRef = useRef(null);

    const handleSendMessage = () => {
      if (message.trim() && wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.send(
          JSON.stringify({
            type: 'chatMessage',
            sessionId,
            text: message,
          })
        );
        setMessages((prev) => [...prev, { sender: 'Bạn', text: message }]);
        setMessage('');
      }
    };

    useEffect(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    return (
      <div style={{ position: 'relative', height: 'calc(100dvh - 64px)', display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            backgroundColor: '#0E100F',
            color: '#FFFCE1',
            fontSize: '16px',
            fontFamily: 'Maven Pro, sans-serif',
            flex: 1,
            overflowY: 'auto',
            padding: '24px',
            boxSizing: 'border-box',
          }}
        >
          {messages.map((msg, index) => (
            <div
              key={index}
              style={{
                marginBottom: '16px',
                textAlign: msg.sender === 'Bạn' ? 'right' : 'left',
              }}
            >
              <p
                style={{
                  display: 'inline-block',
                  padding: '10px 16px',
                  backgroundColor: msg.sender === 'Bạn' ? '#0AE448' : '#42433D',
                  color: msg.sender === 'Bạn' ? '#0E100F' : '#F3FFEE',
                  borderRadius: '20px',
                  maxWidth: '70%',
                  wordBreak: 'break-word',
                }}
              >
                {msg.text}
              </p>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
        <footer
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#0E100F',
            padding: '15px 24px 32px 24px',
            zIndex: 1,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Nhập tin nhắn..."
              style={{
                flex: 1,
                height: '48px',
                padding: '0 16px',
                backgroundColor: '#42433D',
                color: '#F3FFEE',
                border: 'none',
                borderRadius: '24px',
                fontFamily: 'Maven Pro, sans-serif',
                fontSize: '16px',
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') handleSendMessage();
              }}
            />
            <button
              onClick={handleSendMessage}
              disabled={!message.trim()}
              style={{
                width: '48px',
                height: '48px',
                backgroundColor: message.trim() ? '#0AE448' : '#42433D',
                border: 'none',
                borderRadius: '24px',
                cursor: message.trim() ? 'pointer' : 'not-allowed',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M22 2L11 13" stroke={message.trim() ? '#0E100F' : '#F3FFEE'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke={message.trim() ? '#0E100F' : '#F3FFEE'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </footer>
      </div>
    );
  };

  // Render giao diện chính
  return (
    <div style={{ width: '100%', height: '100dvh', overflow: 'hidden', backgroundColor: '#0E100F' }}>
      {!isStarted ? (
        <GettingStartedScreen />
      ) : (
        <>
          <Header />
          {currentStep === 1 && <Step1 />}
          {currentStep === 2 && <Step2 />}
          {currentStep === 3 && <Step3 />}
          {currentStep === 4 && <Step4 />}
          {showConfirmPopup && <ConfirmPopup />}
          {showCancelPopup && <CancelPopup />}
          {showCancelStep1Popup && <CancelStep1Popup />}
        </>
      )}
    </div>
  );
}

export default App;